import { Component, OnInit, TemplateRef, Inject, Input, Output, ViewEncapsulation, ViewChild  } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import { formatDate } from '@angular/common';

import { ExpenseService } from '../services/expense.service';
import { Expense } from '../models/expense.model';
import { ExpenseDialogComponent } from '../expense-dialog/expense-dialog.component';

import { MatTableDataSource } from '@angular/material/table';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { DatePipe } from '@angular/common';

import { GestockService } from '../services/gestock.service';


@Component({
  selector: 'app-expense-tracking',
  templateUrl: './expense-tracking.component.html',
  styleUrls: ['./expense-tracking.component.css']
})
export class ExpenseTrackingComponent implements OnInit {

  expenses: any[] = [];

  samacaabiyoonwii : any ;
  porteeUser="";

  alltypedepenses = [];

  retourClientWS : any ;


  dataSource : MatTableDataSource<any> ;

  datedeb : any ;
  datefin : any ;

  boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';


  displayedColumns: string[] = ['datecreat', 'boutique_nom', 'description', 'categorie', 'montant' , 'nomlieudepense','debperiode', 'finperiode'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filteredData : any ;



  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;

  
  constructor(private expenseService: ExpenseService, private dialog: MatDialog, private configServer: GestockService) {
    this.datedeb = new Date(); 
    this.datefin = new Date();        
  }

  ngOnInit() {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.porteeUser =  sessionStorage.getItem("portee") ;
    this.getAllPoints(); 
  }


  getAllPoints(){
    this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("Done") ;
        this.boutiques = this.retourClientWS.data ; 
        if(this.boutiques.length==1)
          this.selectedBoutique = this.boutiques[0].idPoint ;
        this.getAllKindOfExpenses() ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  onBoutiqueChange(): void {
  }


  getAllKindOfExpenses(){

    this.configServer.getAllKindOfExpenses(this.samacaabiyoonwii).then( (retourbi) => {

      this.loadExpenses();

      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.alltypedepenses = this.retourClientWS.data ;
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }


  applyFilterValue(value) {
    const filterValue = value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }

  getTotal(cible){
    let total = 0 ;
    let totalFixe = 0 ;
    let totalVariable = 0 ;
    for (var i = 0; i < this.expenses.length; i++) {
      if(cible=='')
        total += Number(this.expenses[i].montant) ;
      if(this.expenses[i].categorie=='Fixe')
        totalFixe += Number(this.expenses[i].montant) ;
      if(this.expenses[i].categorie=='Variable')
        totalVariable += Number(this.expenses[i].montant) ;
    }

    if(cible=='Fixe')
      return totalFixe ;
    if(cible=='Variable')
      return totalVariable ;
    else
      return total ;
  }



  loadExpenses(){

    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    this.openSpinnerDialog() ;
    this.configServer.getAllDepenses(this.samacaabiyoonwii,  this.selectedBoutique, debut, fin).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.expenses = this.retourClientWS.data ;
        this.dataSource =  new MatTableDataSource(this.expenses) ;
        this.filteredData = this.dataSource.data ;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }


  openAddDialog() {
    let allDepTyp =  this.alltypedepenses ;
    const dialogRef = this.dialog.open(ExpenseDialogComponent, {
      width: '400px',  data: { 'allDepTyp': allDepTyp, shop:this.selectedBoutique }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.expenseService.addExpense(result);
        this.loadExpenses();
      }
    });
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}